import { getChatReplyTemplatesApi } from '@/core/api/generatedApiClient';
import { INLINE_API_ERROR_OPTIONS } from '@/core/api/requestErrorMode';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { ChatReplyCatalogResponse, SaveChatReplyFolderRequest, SaveChatReplyTemplateRequest } from '@/core/generated/api';

/** Предоставляет операции с папками и шаблонами сообщений чата */
export const chatReplyTemplateService = {
    /** Загружает каталог шаблонов */
    async getCatalog(): Promise<ChatReplyCatalogResponse> {
        try {
            const response = await getChatReplyTemplatesApi().getChatReplyCatalog({}, INLINE_API_ERROR_OPTIONS);

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error, 'inline');
        }
    },

    /** Сохраняет папку шаблонов */
    async saveFolder(request: SaveChatReplyFolderRequest, id?: string): Promise<string> {
        try {
            if (id) {
                await getChatReplyTemplatesApi()
                    .updateChatReplyFolder({
                        id,
                        saveChatReplyFolderRequest: request
                    }, INLINE_API_ERROR_OPTIONS);

                return id;
            }

            const response = await getChatReplyTemplatesApi().createChatReplyFolder({ saveChatReplyFolderRequest: request }, INLINE_API_ERROR_OPTIONS);

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error, 'inline');
        }
    },

    /** Сохраняет шаблон сообщения */
    async saveTemplate(request: SaveChatReplyTemplateRequest, id?: string): Promise<string> {
        try {
            if (id) {
                await getChatReplyTemplatesApi()
                    .updateChatReplyTemplate({
                        id,
                        saveChatReplyTemplateRequest: request
                    }, INLINE_API_ERROR_OPTIONS);

                return id;
            }

            const response = await getChatReplyTemplatesApi().createChatReplyTemplate({ saveChatReplyTemplateRequest: request }, INLINE_API_ERROR_OPTIONS);

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error, 'inline');
        }
    },

    /** Удаляет пустую папку */
    async deleteFolder(id: string, version: string): Promise<void> {
        try {
            await getChatReplyTemplatesApi()
                .deleteChatReplyFolder({
                    id,
                    version
                }, INLINE_API_ERROR_OPTIONS);
        } catch (error: unknown) {
            return rethrowHandledApiError(error, 'inline');
        }
    },

    /** Удаляет шаблон сообщения */
    async deleteTemplate(id: string, version: string): Promise<void> {
        try {
            await getChatReplyTemplatesApi()
                .deleteChatReplyTemplate({
                    id,
                    version
                }, INLINE_API_ERROR_OPTIONS);
        } catch (error: unknown) {
            return rethrowHandledApiError(error, 'inline');
        }
    },
};
